import {
  QueryClient,
  QueryCache,
  MutationCache,
  type Query,
  type Mutation,
} from '@tanstack/react-query';
import { subscribeCacheControl } from './control';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
      retry: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error: Error, query: Query<unknown, unknown, unknown>): void => {
      console.error(
        `Failed to fetch [${query.queryKey.join('_') ?? '-'}] data:`,
        error
      );
    },
  }),
  mutationCache: new MutationCache({
    onError: (
      error: Error,
      _variables,
      _context,
      mutation: Mutation<unknown, unknown, unknown>
    ): void => {
      console.error(
        `Failed to execute mutation [${mutation.options.mutationKey?.join('_') ?? '-'}]:`,
        error
      );
    },
  }),
});

// モジュール読み込み時に、初期化処理としてキャッシュ制御を購読しておく
subscribeCacheControl(queryClient);

export { queryClient };
